var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 489,
    viewBox: "0 0 489 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 106,
    width: 73,
    height: 312,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.125 412.013L271.925 44.413C259.625 23.113 228.825 23.113 216.525 44.413L4.325 412.013C-7.975 433.313 7.425 460.013 32.025 460.013H456.425C481.025 460.013 496.425 433.313 484.125 412.013ZM244.525 157.613C258.125 157.613 269.125 168.913 268.725 182.513L264.725 322.113C264.425 333.113 255.425 341.813 244.425 341.813C233.425 341.813 224.425 333.013 224.125 322.113L220.225 182.513C219.925 168.913 230.825 157.613 244.525 157.613ZM244.225 410.113C230.325 410.113 219.025 398.813 219.025 384.913C219.025 371.013 230.325 359.713 244.225 359.713C258.125 359.713 269.425 371.013 269.425 384.913C269.425 398.813 258.125 410.113 244.225 410.113Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488.451,
    height: 488.451,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.d6d5186eac145a5439d3f99f58530f2e.svg";
export { ForwardRef as ReactComponent };